/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";

import React from "react";

const Contact: React.FC = () => {
  return (
    <svg
      width="79"
      height="61"
      viewBox="0 0 79 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7811_4341)">
        <mask
          id="mask0_7811_4341"
          maskUnits="userSpaceOnUse"
          x="0"
          y="-9"
          width="79"
          height="79"
        >
          <path d="M0 -9H79V70H0V-9Z" fill="white" />
        </mask>
        <g mask="url(#mask0_7811_4341)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27.9185 32.6683C27.5976 32.6683 27.3377 32.4089 27.3377 32.0889V2.91111C27.3377 2.59106 27.5976 2.33175 27.9185 2.33175H32.7729C33.4184 2.33175 33.9417 1.80977 33.9417 1.16587C33.9417 0.52198 33.4184 0 32.7729 0H27.9185C26.3066 0 25 1.30327 25 2.91111V32.0889C25 33.6967 26.3066 35 27.9185 35H76.0815C77.6934 35 79 33.6967 79 32.0889V2.91111C79 1.30327 77.6934 0 76.0815 0H38.2274C37.5819 0 37.0586 0.52198 37.0586 1.16587C37.0586 1.80977 37.5819 2.33175 38.2274 2.33175H76.0815C76.4024 2.33175 76.6623 2.59106 76.6623 2.91111V32.0889C76.6623 32.4089 76.4024 32.6683 76.0815 32.6683H27.9185Z"
            fill="#006DAE"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M51.1628 17.4396C51.1628 17.4396 51.1628 17.4395 51.1628 17.4395L27.8098 1.20631C27.288 0.843573 26.5703 0.971651 26.2068 1.49239C25.8432 2.01312 25.9716 2.72932 26.4934 3.09206L49.8464 19.3253L49.8465 19.3253C51.1406 20.2249 52.8594 20.2249 54.1535 19.3253L54.1536 19.3253L77.5066 3.09206C78.0284 2.72932 78.1568 2.01312 77.7933 1.49239C77.4297 0.971651 76.712 0.843573 76.1902 1.20631L52.8372 17.4395C52.8372 17.4395 52.8372 17.4396 52.8372 17.4396C52.3341 17.7892 51.6659 17.7892 51.1628 17.4396Z"
            fill="#006DAE"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M64.7819 24.4852C65.1653 23.9408 65.03 23.1919 64.4797 22.8126L54.9087 16.2158C54.3584 15.8364 53.6015 15.9703 53.2181 16.5148C52.8347 17.0592 52.97 17.8081 53.5203 18.1874L63.0913 24.7842C63.6416 25.1636 64.3985 25.0297 64.7819 24.4852Z"
            fill="#006DAE"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M77.8 34.4853C78.1515 33.9409 78.0275 33.192 77.523 32.8127L68.7499 26.2158C68.2454 25.8365 67.5515 25.9703 67.2 26.5147C66.8485 27.0591 66.9725 27.808 67.477 28.1873L76.2501 34.7842C76.7546 35.1635 77.4485 35.0297 77.8 34.4853Z"
            fill="#006DAE"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.2079 34.4797C26.5734 35.03 27.2951 35.1653 27.8198 34.782L50.5039 18.2107C51.0286 17.8274 51.1576 17.0706 50.7921 16.5203C50.4266 15.97 49.7049 15.8347 49.1802 16.218L26.4961 32.7893C25.9714 33.1726 25.8424 33.9294 26.2079 34.4797Z"
            fill="#006DAE"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.5456 58.3278C39.1233 58.7927 36.6017 58.7943 34.1145 58.2884C34.1118 58.2878 34.109 58.2872 34.1062 58.2867C18.2928 55.0668 5.93416 42.7078 2.71435 26.8941C2.71381 26.8914 2.71326 26.8886 2.71271 26.8859C1.43071 20.5833 3.39488 14.0579 7.94268 9.51C9.519 7.93365 12.0745 7.93365 13.6508 9.50999L20.193 16.0525L20.1931 16.0525C21.4217 17.281 21.2807 19.3121 19.8941 20.3592L15.8267 23.4307L15.8266 23.4308C13.5179 25.1746 12.7002 28.3648 14.0701 30.9782L14.0712 30.9802C14.1089 31.0519 14.1493 31.1259 14.1927 31.201C14.1928 31.2011 14.1928 31.2012 14.1929 31.2013C17.9308 37.6811 23.32 43.0702 29.7995 46.8081L29.8 46.8084C29.8727 46.8503 29.9468 46.8912 30.0223 46.9307C32.6356 48.3008 35.826 47.483 37.5694 45.1741C37.5695 45.1741 37.5695 45.1741 37.5695 45.174L40.6411 41.1066C41.6881 39.7201 43.7192 39.5791 44.9479 40.8077L51.4902 47.3501C53.0664 48.9263 53.0664 51.4821 51.4902 53.0583C50.079 54.4694 48.4772 55.6313 46.7508 56.5252C46.18 56.8208 45.9569 57.5231 46.2525 58.0939C46.548 58.6647 47.2503 58.8879 47.8211 58.5923C49.7569 57.5899 51.5535 56.2868 53.1361 54.7042C55.6213 52.219 55.6213 48.1894 53.1361 45.7042L46.5938 39.1617L46.5937 39.1617C44.3656 36.9337 40.6824 37.1894 38.7835 39.7038L39.6505 40.3586L38.7835 39.7038L35.7119 43.7713L35.7119 43.7713C34.6199 45.2175 32.6572 45.6839 31.103 44.8691L31.103 44.8691C31.0566 44.8448 31.0098 44.819 30.9626 44.7918C30.9625 44.7918 30.9624 44.7917 30.9623 44.7916M30.9621 44.7915C24.8371 41.258 19.7423 36.1632 16.209 30.0378L16.2086 30.0372C16.183 29.993 16.1573 29.9461 16.1311 29.8964C15.3172 28.3424 15.7836 26.3803 17.2295 25.2882L21.2968 22.2168C23.8114 20.3179 24.0671 16.6346 21.839 14.4065C21.839 14.4065 21.8389 14.4065 21.8389 14.4065L15.2968 7.86405L14.5522 8.60864L15.2968 7.86404C12.8114 5.37865 8.78209 5.37865 6.29676 7.86404C1.19877 12.9621 -1.00421 20.2762 0.430034 27.3415C0.430588 27.3444 0.431154 27.3472 0.431729 27.35C3.83573 44.0857 16.915 57.1653 33.6504 60.5694C33.6533 60.57 33.6561 60.5705 33.659 60.5711C36.4465 61.137 39.2718 61.1344 41.9844 60.6138C42.6156 60.4926 43.0291 59.8827 42.908 59.2514C42.7868 58.6201 42.1769 58.2066 41.5456 58.3278"
            fill="#006DAE"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7811_4341">
          <rect width="79" height="61" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Contact;
